import { defineMessages } from 'react-intl';

export default defineMessages({
    flexProgram: {
        id: 'wmic-pe-capability-gateway-common-react.FlexProgram.Flex Program',
        defaultMessage: 'Flex Program',
    },
});
